import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Loader2, PenLine } from "lucide-react";
import { toast } from "sonner";

export default function ESignDialog({ contract, open, onOpenChange, onSigned }) {
  const [name, setName] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [saving, setSaving] = useState(false);

  const sign = async () => {
    if (!name.trim() || !agreed) return toast.error("Type your name and confirm agreement");
    setSaving(true);
    try {
      await api.post(`/contracts/${contract.id}/esign`, { signer_name: name.trim(), signature: name.trim(), agreed: true });
      toast.success("Contract signed");
      setName(""); setAgreed(false);
      onSigned && onSigned();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-black/10 rounded-none max-w-md">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><PenLine className="h-4 w-4 text-primary" /> Sign contract</DialogTitle></DialogHeader>
        {contract && (
          <div className="space-y-4">
            <div className="border border-black/10 bg-[#F4F4F5] p-4">
              <p className="overline text-[0.55rem]">{(contract.contract_type || "").replace(/_/g, " ")}</p>
              <p className="text-sm font-medium mt-1">{contract.filename}</p>
              <p className="text-xs text-muted-foreground">{contract.organization_name}</p>
            </div>
            <div className="space-y-2">
              <Label>Type your full legal name to sign</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} data-testid="esign-name" placeholder="Jane A. Doe"
                className="bg-[#F4F4F5] border-black/10 rounded-none font-heading text-lg italic" />
            </div>
            <label className="flex items-start gap-2 text-sm text-muted-foreground cursor-pointer">
              <Checkbox checked={agreed} onCheckedChange={setAgreed} data-testid="esign-agree" className="mt-0.5" />
              I agree that typing my name constitutes my legal electronic signature on this document.
            </label>
            <DialogFooter>
              <Button onClick={sign} disabled={saving} data-testid="esign-submit" className="rounded-none bg-primary hover:bg-[#09090B]">
                {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Adopt & sign"}
              </Button>
            </DialogFooter>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
